<div class="container" [class.disabled]="disabled">
  <mat-form-field class="zef-input-number" [class.zef-input-space]="space">
    <input
      matInput
      [value]="parseValue(value)"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (keydown.arrowUp)="onArrowKeyDown('increment', $event)"
      (keydown.arrowDown)="onArrowKeyDown('decrement', $event)"
      (keyup.arrowUp)="onArrowKeyUp('increment')"
      (keyup.arrowDown)="onArrowKeyUp('decrement')"
      (blur)="onBlur()"
      (input)="validateNumericValue($event.target.value)"
      (change)="$event.stopPropagation()"
    />
    <div class="z-fx-col z-fx-center-center input-arrows" matSuffix>
      <mat-icon class="input-arrow zef-icon-small" tabindex="-1" (pointerdown)="startIncrement()">pointer_up</mat-icon>

      <mat-icon class="input-arrow zef-icon-small" tabindex="-1" (pointerdown)="startDecrement()">
        pointer_down
      </mat-icon>
    </div>
  </mat-form-field>
</div>
